/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class OtherInfo extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default OtherInfo;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/otherInfo.js